import NoodleIsNowGladeBanner from '@/components/NoodleIsNowGladeBanner';

import s from './LoggedInUserGate.module.scss';

const BasicWrapper: React.FC = ({ children }) => (
  <>
    <NoodleIsNowGladeBanner />
    <div className={s.wrapper}>
      {children}
    </div>
  </>
);

export default BasicWrapper;
